<div class="text-center margin-vertical mv24">
  <ng-container>
    <div class="grey-color">
      {{ 'MAKE_SURE_TO_REVIEW_YOUR_SPAN_FOLDER' | translate }}
    </div>
    <div class="grey-color">
      {{ 'FORGOT_EMAIL_CONFIMATION_SUBTITLE' | translate }}
    </div>
    <div class="resend-mr" [ngClass]="{ 'mt-2 padding-bottom pb16 ': !isAcmic }">
      <mapfre-link
        additionalClasses="small-link {{isAcmic? 'blue-link resend-text' : 'dm-sans-medium font-weight-500 font-size-16' }}"
        [ngClass]="{ 'color-DF0027 corporate-red font-weight-500': !isAcmic, 'blue-link': isAcmic }"
        (click)="goBackToForm()">
        {{ 'FORGOT_EMAIL_SEND_AGAIN' | translate }}</mapfre-link>
    </div>

    <div class="text-center whiteSpaceNoWrap" [ngClass]="{ 'grey-color padding-bottom pb16': !isAcmic }">
      <div class="mb-2">
        {{ 'OR_CONTACT_OUR_CUSTOMER_SERVICE' | translate }}
      </div>
      <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mt-2 mapfre link font-size-16 underlineLink"
        [ngClass]="{ 'corporate-red dm-sans-medium font-weight-500': !isAcmic,'blue-link': isAcmic }">
        {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="isAcmic; else otherState">
    <div class="row text-center">
      <div class="col">
        <mapfre-button additionalClasses="link-button small red-link margin-top mt24"
          [backIcon]="'assets/img/icons/back-arrow-red.png'" [iconClasses]="'align-middle'" [routerLink]="['/login']"
          [showIconsCustom]="true"> {{ 'BACK' | translate }}
        </mapfre-button>
      </div>
    </div>
  </ng-container>
  <ng-template #otherState>
    <div class="grey-color" *ngIf="showMessageApp">
      {{ 'MA_ONLY_APP_NOTIFICATION' | translate }}
    </div>
  </ng-template>

</div>